import React from 'react';
import Page from '../../containers/page';
import RouteComponent from '../../helpers/route';
import ExternalApiAnalytics from '../../components/externalApiAnalytics';
import { toLogsFilters } from '../../helpers/externalApiLogs';

const FILTER_KEYS = ['preset', 'customFrom', 'customTo', 'interval', 'clientId', 'clientLabel', 'route', 'method', 'apiKeyId', 'apiKeyLabel', 'replica'];

class Screen extends RouteComponent {
    _initialFilters = () => {
        let params = this._getParams();
        let filters = {};
        FILTER_KEYS.forEach((key) => { filters[key] = params[key] || ''; });
        return filters;
    }

    _onFiltersChange = (filters) => {
        this.updateMultipleParams(FILTER_KEYS.map((key) => ({ name: key, value: filters[key] })), false);
    }

    _onOpenClient = (row) => {
        // There is no "get client by id" endpoint, so this takes the user to
        // the customers API usage list pre-filtered to that client (by customer
        // number, falling back to username) and asks it to open that client's
        // own "API analytics" tab once it loads - see customers-api-usage/screen.js.
        let filterValue = row.customerNumber || row.username || '';
        this.props[0].history.push(
            `/customers-api-usage?filter=${encodeURIComponent(filterValue)}&focusClientId=${encodeURIComponent(row.clientId)}&focusClientTab=apiAnalytics`
        );
    }

    _onOpenLogs = (filters) => {
        let logsFilters = toLogsFilters(filters);
        let qs = new URLSearchParams();

        Object.keys(logsFilters).forEach((key) => {
            if (logsFilters[key]) qs.set(key, logsFilters[key]);
        });

        this.props[0].history.push(`/external-api-logs?${qs.toString()}`);
    }

    render() {
        return (
            <div>
                <div className="section-title title-options">
                    <h1>{'External API Analytics'.translate(this.props.lang)}</h1>
                </div>

                <ExternalApiAnalytics
                    lang={this.props.lang}
                    initialFilters={this._initialFilters()}
                    onFiltersChange={this._onFiltersChange}
                    onOpenClient={this._onOpenClient}
                    onOpenLogs={this._onOpenLogs}
                />
            </div>
        );
    }
}

export default Page(Screen);
